import { GenericError, IErrorDetails } from '@cian/peperrors/shared';

export class ChatMessageVerificationError extends GenericError {
  public constructor(configuration: { domain: string; message: string; details?: IErrorDetails }) {
    super({
      ...configuration,
      type: 'ChatMessageVerificationError',
    }) /* istanbul ignore next */;

    Object.setPrototypeOf(this, ChatMessageVerificationError.prototype);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ChatMessageVerificationError);
    } else {
      this.stack = new Error().stack;
    }
  }
}
